/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduledEmail } from '../../models/scheduled-email';

export interface UpdateScheduledEmail$Params {
  id: string;
      body?: ScheduledEmail
}

export function updateScheduledEmail(http: HttpClient, rootUrl: string, params: UpdateScheduledEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduledEmail>> {
  const rb = new RequestBuilder(rootUrl, updateScheduledEmail.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduledEmail>;
    })
  );
}

updateScheduledEmail.PATH = '/emails/{id}';
